import { useQuery } from '@tanstack/react-query'
import {
  fetchDistributionCenters,
  fetchLineDistributionCenters,
} from '@/api/distributionCenters'
import { queryKeys } from '@/lib/queryKeys'

export function useDistributionCenters() {
  return useQuery({
    queryKey: queryKeys.distributionCenters.all,
    queryFn: fetchDistributionCenters,
  })
}

export function useLineDistributionCenters(
  planId: string | undefined,
  versionId: string | undefined,
  lineId: string | undefined
) {
  return useQuery({
    queryKey: queryKeys.distributionCenters.byLine(
      planId ?? '',
      versionId ?? '',
      lineId ?? ''
    ),
    queryFn: () => fetchLineDistributionCenters(planId!, versionId!, lineId!),
    enabled: !!planId && !!versionId && !!lineId,
  })
}
